import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';
import { useEffect, useMemo, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDebounce } from 'use-lodash-debounce';

import { UnregisteredClientId } from '../../../../../../../types/api/orders';
import { halfSecundDebounceTimeout } from '../../../../../../../utils/constants/misc';
import { invalidDecimalPointCharactersRegex } from '../../../../../../../utils/constants/regex';
import FieldWithErrors from '../../../../../../Forms/ReactHookForm/FieldWithErrors/FieldWithErrors';
import {
  FormFields,
  RedemptionFieldValidation,
  RedemptionReceiverFieldValidation,
  getRedemptionTooltip,
  validateRedemptionField,
} from '../../../CreateEditRecreate.functions';

function Redemption(): JSX.Element {
  const { t } = useTranslation();

  const vrednost = useWatch<FormFields, 'vrednost'>({
    name: 'vrednost',
  });

  const klient_od_id = useWatch<FormFields, 'klient_od_id'>({
    name: 'klient_od_id',
  });

  const klient_do_id = useWatch<FormFields, 'klient_do_id'>({
    name: 'klient_do_id',
  });

  const { setValue, getValues } = useFormContext<FormFields>();

  const [redemption, setRedemption] = useState<string>(
    getValues('otkup') ?? '0.00'
  );

  const debouncedRedemption = useDebounce(
    redemption,
    halfSecundDebounceTimeout
  );

  const redemptionFieldValidation = useMemo(
    () => validateRedemptionField(klient_od_id, vrednost),
    [klient_od_id, vrednost]
  );

  const redemptionTooltip = useMemo(
    () => getRedemptionTooltip(t, redemptionFieldValidation),
    [redemptionFieldValidation, t]
  );

  useEffect(() => {
    setValue('otkup', debouncedRedemption); // to prevent calling calculator on key up
  }, [debouncedRedemption, setValue]);

  const isRedemptionDisabled =
    redemptionFieldValidation ===
      RedemptionFieldValidation.UnregisteredSender &&
    klient_do_id !== UnregisteredClientId.Recipient;

  // const isRedemptionReceiverDisabled =
  //   RedemptionReceiverFieldValidation !==
  //   RedemptionReceiverFieldValidation.Valid;

  return (
    <>
      <Tooltip
        target=".disabled-redemption-tooltip"
        position="left"
        style={isRedemptionDisabled ? {} : { display: 'none' }}
      />

      {/* <Tooltip
        target=".disabled-redemption-receiver-tooltip"
        position="left"
        style={isRedemptionReceiverDisabled ? {} : { display: 'none' }}
      /> */}

      <FieldWithErrors name="otkup" label={t('Redemption')}>
        <Controller
          name="otkup"
          render={() => (
            <div
              data-pr-tooltip={redemptionTooltip}
              className="disabled-redemption-tooltip"
            >
              <InputText
                id="otkup"
                name="otkup"
                value={isRedemptionDisabled ? 0 : redemption}
                disabled={isRedemptionDisabled}
                onChange={(e) => {
                  setRedemption(
                    // 'otkup',
                    e.target.value.replace(
                      invalidDecimalPointCharactersRegex,
                      ''
                    )
                  );
                }}
                className="data-cy-redemption"
              />
            </div>
          )}
        />
      </FieldWithErrors>
    </>
  );
}

export default Redemption;
